/* eslint-disable prettier/prettier */
/* eslint-disable react/prop-types */
import React from "react";
import { Box, Typography } from "@mui/material";
import UnderDevelopment from "../../assets/svg/UnderDevelopment";

function PageUnderReview() {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        minHeight: "85vh",
        background: "#FFFFFF",
        border: "1px solid #C4C4C4",
        borderRadius: "8px",
        margin: "25px",
      }}
    >
      <UnderDevelopment />
      <Typography
        varient="p"
        sx={{
          fontWeight: "500",
          fontSize: "18px",
          lineHeight: "21px",
          color: "#FF0000",
          marginTop: "21px",
        }}
      >
        Page Under Development
      </Typography>
    </Box>
  );
}

export default PageUnderReview;
